import { Skeleton } from '@/components/ui/skeleton';

export function CourseCardSkeleton() {
  return (
    <div className="flex flex-col w-full">
      {/* Image skeleton */}
      <div className="relative w-full h-[200px] sm:h-[220px] overflow-hidden rounded-lg">
        <Skeleton className="w-full h-full bg-surface-3" />
      </div>

      {/* Content skeleton */}
      <div className="p-3 sm:p-4 flex flex-col gap-2 bg-surface-2">
        {/* Title skeleton - 2 lines */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-5 w-full bg-surface-3" />
          <Skeleton className="h-5 w-3/4 bg-surface-3" />
        </div>

        {/* Label and Duration skeleton */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-16 bg-surface-3" />
          <div className="h-4 w-px bg-border-medium" />
          <Skeleton className="h-4 w-20 bg-surface-3" />
        </div>
      </div>
    </div>
  );
}

